import { render } from "./Loan_Statement.vue?vue&type=template&id=6a9bfdae&scoped=true"
import script from "./Loan_Statement.vue?vue&type=script&lang=js"
export * from "./Loan_Statement.vue?vue&type=script&lang=js"

import "./Loan_Statement.vue?vue&type=style&index=0&id=6a9bfdae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9bfdae"]])

export default __exports__